import type { ReactNode } from 'react';
import { AuditTicker } from './AuditTicker';
import { CommandLine } from './CommandLine';
import { Header } from './Header';
import { NavRail } from './NavRail';
import { TimeScrubber } from './TimeScrubber';

// The frame every page lives in. Header / NavRail / canvas / scrubber /
// command line / audit ticker. Page content goes into the canvas slot.
export function Shell({ children }: { children: ReactNode }) {
  return (
    <div
      className="eid shell-root"
      style={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        background: 'var(--bg-base)',
      }}
    >
      <Header />
      <div
        className="shell-body"
        style={{ flex: 1, display: 'flex', overflow: 'hidden', minHeight: 0 }}
      >
        <NavRail />
        <main
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            minWidth: 0,
          }}
        >
          {children}
        </main>
      </div>
      <div className="shell-time-scrubber">
        <TimeScrubber />
      </div>
      <div className="shell-command-line">
        <CommandLine />
      </div>
      <div className="shell-audit-ticker">
        <AuditTicker />
      </div>
    </div>
  );
}
